import React from "react";
import PageHeaderWrapper from "../../components/PageHeaderWrapper";
import { Row, Col, Tabs, Card, Tooltip, Icon, Button, notification, Drawer, Form, Steps } from 'antd';
import { TableComp } from 'sz-react-utils'
import { connect } from "react-redux";
import Request, { API_URL, LAPI_URL } from "../../request";
import LatestFollowUp from "../../components/_utils/latestFollowup";
import ListFollowUps from "../../components/_utils/listFollowUp";
import ListRawFollowUp from '../../components/_utils/listRawInquiryFollowUp';
import ClickToCallDrawer from "../Student/inquiry/all/clickToCall";
import rightAuth from "../../components/_utils/userRights";
import { FormUtils as GetAllFormFields } from 'sz-react-utils';
import renderHTML from "react-render-html";
import _ from 'lodash';
import async from 'async';
import moment from "moment";
const dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : "DD.MM.YYYY"
const { TabPane } = Tabs
const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
let studentObj = {};
let rawStudentObj = {};
const { Step } = Steps


class CommunicationHistoryDrawer extends React.Component {
    state = {
        visible: true,
        studentId: "",
        count: 0,
        activityArr: [],
        data: [],
        activeKey: 0,
        completeInfo: null,
        notesActivityArr: [],
        drawerVisible: false,
    }

    async componentDidMount() {
        let { studentId } = this.props;
        this.setState({ studentId: studentId }, () => {
            this.apiRequest();
            this.apiNotesRequest();
        });
    }

    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose();
        }, 50)
    }

    apiCallHistoryRequest = (params) => {
        return new Promise(async (resolve) => {
            params.studentId = this.state.studentId;
            let response = await Request.getCallDetailsByStudent(params);
            return resolve(response);
        })
    }

    async apiNotesRequest() {
        let { studentId } = this.state;
        if (studentId) {
            let data = await Request.loadStudentMovedReasons(studentId)
            this.setState({ notesActivityArr: data.data })
        }
    }

    showDrawer = () => {
        this.setState({
            drawerVisible: true,
        });
    };

    apiRequest = (params) => {
        return new Promise(async (resolve) => {
            if (!params) {
                params = {}
            }
            params.studentId = this.state.studentId;
            let response = await Request.loadStudentCommunicationHistory({ ...params, regExFilters: ["message", "desk"] });
            // let response = await Request.loadStudentActivities({...params, regExFilters:["message", "desk"]})
            this.setState({ activityArr: response.data })
            resolve(response)
        })
    }

    renderFlowDetails = (key) => {
        if (key.details) {
            return (
                <div>
                    {" "}
                    {key.message}
                    <Button
                        style={{
                            marginLeft: "12px",
                            padding: "3px",
                            height: "23px",
                        }}
                        type="primary"
                        onClick={() => {
                            this.showDrawer();
                            this.setState({ smsDetails: key.details });
                        }}
                    >
                        {<Icon type="eye" />}
                    </Button>
                </div>
            );
        }

        if (key.message) {
            return <div>{key.message}</div>;
        }
    };


    render() {
        let { visible } = this.state;
        const notesColumn = [
            {
                title: 'At Level',
                key: 'atLevel',
                dataIndex: 'atLevel',
                width: 150,
            },
            {
                title: 'Reason',
                key: 'moveReason',
                dataIndex: 'moveReason',
                width: 150,
            },
            {
                title: 'Reason Type',
                key: 'moveReasonType',
                dataIndex: 'moveReasonType',
                width: 150,
            },
            {
                title: 'Reason By User',
                key: 'moveReasonUser',
                dataIndex: 'moveReasonUser',
                width: 250,
                render: (val, record) => {
                    return (<div>
                        <div>Name:- {record.user && record.user.name} </div>
                        <div>Email:- {record.user && record.user.email} </div>
                        <div>Mobile:- {record.user && record.user.userMobile} </div>
                        <div>Branch:- {record.user && record.user.branchHead} - {record.user && record.user.branch} </div>
                    </div>)
                }
            },
            {
                title: 'Done By',
                key: 'createdByUser.name',
                dataIndex: 'createdByUser.name',
                width: 150,
                render: (val, record) => {
                    return (<div>{record.createdByUser && record.createdByUser.name} </div>)
                }
            },
            {
                title: 'Date',
                key: 'createdByUser.time',
                dataIndex: 'createdByUser.time',
                width: 150,
                render: (val, record) => {
                    return (<div> {moment(record.createdByUser.time).format('DD-MMM-YYYY hh:mm:A')} </div>)
                }
            }
        ];
        const columns = [
            {
                title: 'Sr. No',
                key: 'serialNumber',
                width: 80,
                render: (text, record, index) => (
                    <div>{index + 1}</div>
                )
            },
            {
                title: 'Student Name',
                key: 'studentName'
            },
            {
                title: 'V.I.D',
                key: 'id'
            },
            {
                title: 'Interested In',
                key: 'interestedIn'
            },
            {
                title: 'Call Date',
                key: 'callDate',
                render: (text, record) => (
                    <div>{moment(record.callDate).format(dateFormat)}</div>
                )
            },
            {
                title: 'Call Time',
                key: 'callTime',
                render: (text, record) => (
                    <div>{moment(record.callDate).format("HH:mm A")}</div>
                )
            },
            {
                title: 'Call Status',
                key: 'callStatus'
            },
            {
                title: 'Remark',
                key: 'remark'
            }

        ];
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Communication History
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={1200}
                visible={visible}>
                <Card bordered={true}>
                    <Tabs onChange={this.onChange} type="card">
                        {/* Whatsapp or Email Tab */}
                        <TabPane tab={"Whatsapp/Email"} key={0}>

                            <Card bordered={true}>
                                <Steps direction="vertical" size="small" current={0}>

                                    {/* <Step title={"check"} description={"check"} icon={<Icon type="loading" />}/> */}
                                    {this.state.activityArr.map((activity, index) => {
                                        return (
                                            <Step status="process" title={this.renderFlowDetails(activity)} description={<div>{activity.desk ? `${activity.desk} Desk |` : ""}  {activity.createdByUser ? `Done By:- ${activity.createdByUser.name} |` : ""}  {activity.createdByUser ? `Date:- ${moment(activity.createdByUser.time).format("DD-MMM-YYYY hh:mm A")}` : ""}</div>} icon={index === 0 ? <Icon type="check-circle" theme="twoTone" /> : <Icon type="up-circle" theme="twoTone" />} />
                                        )
                                    })}
                                </Steps>
                            </Card>
                        </TabPane>
                        <TabPane tab={"Call History"} key={1}>
                            <Card bordered={true}>
                                <TableComp
                                    ref={this.table}
                                    columns={columns}
                                    apiRequest={this.apiCallHistoryRequest}
                                    extraProps={{ scroll: { x: 900 } }}
                                    pagination={{
                                        showSizeChanger: true,
                                        defaultPageSize: 10,
                                        pageSizeOptions: ['10', '20', '50', '100', '1000']
                                    }}
                                />
                            </Card>
                        </TabPane>
                        {/* <TabPane tab={"Notes"} key={2}>
                            <Card bordered={true}>
                                <TableComp
                                    columns={notesColumn}
                                    dataSource={this.state.notesActivityArr}
                                    pagination={false} bordered
                                />
                            </Card>
                        </TabPane> */}
                    </Tabs>

                </Card>
                {!!this.state.drawerVisible && (
                    <Drawer
                        title=""
                        placement="right"
                        closable={true}
                        onClose={() => {
                            this.setState({
                                drawerVisible: false,
                            });
                        }}
                        visible={this.state.drawerVisible}
                        width={1000}
                    >
                        {this.state && this.state.smsDetails && (
                            <div>
                                <h2
                                    style={{
                                        marginLeft: "11px",
                                        marginTop: "13px",
                                        color: "orange",
                                    }}
                                >
                                    Communication Details
                                </h2>

                                <p
                                    style={{
                                        padding: "10px",
                                        textAlign: "justify",
                                        marginLeft: "4px",
                                        marginRight: "50px",
                                    }}
                                >
                                    {/*
               {this.state.smsDetails ? S(this.state.smsDetails).stripTags().s : null}
               */}
                                    {this.state.smsDetails
                                        ? renderHTML(this.state.smsDetails)
                                        : null}
                                </p>
                            </div>
                        )}
                    </Drawer>
                )}
            </Drawer>
        )
    }
}


@Form.create()
class DisapproveFollowUp extends React.Component {
    state = {
        visible: true,
        followUpObject: [],
        reassignLead: false,
        countriesArr: [],
        counsellorsArr: [],

    }

    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose()
        }, 50)
    }

    loadFollowUpTypes = async () => {
        let params = {
            results: 10000,
            count: 10000
        }
        let response = await Request.getFollowUpTypes(params)
        let followUpObject = []
        _.each(response.data, (followUp) => {
            followUpObject.push({ id: followUp.name, display: followUp.name })
        })
        this.setState({ followUpObject })
    }


    setFormData = () => {
        let { record, form: { setFieldsValue } } = this.props;
        let countryIds = [];
        if (record && record.totalPreference && record.totalPreference.length > 0) {
            async.each(record.totalPreference, (preference) => {
                if (record.type === "inquiry") {
                    countryIds.push(preference.countryId);
                } else if (record.type === "rawInquiry") {
                    let foundCountry = this.state.countriesArr.filter((obj) => {
                        return obj.display === preference;
                    })
                    if (foundCountry) {
                        countryIds.push(foundCountry.id);
                    }
                }
            })
        }
        setTimeout(() => {
            setFieldsValue({ counsellorId: record.counsellorId, atLevel: record.atLevel, totalPreference: countryIds });
        }, 500)

    }


    loadCountries = async () => {
        let params = {
            results: 10000,
            count: 10000,
            businessId: activeUser && activeUser.businessId
        }
        let response = await Request.getCountriesWithoutAuth(params);
        response.data = response.data.reduce((temp, vv) => {
            temp.push({ id: vv._id, display: vv.countryName });
            return temp;
        }, []);
        this.setState({ countriesArr: response.data });
    }

    loadCounsellors = async () => {
        let { data } = await Request.loadAllCounsellors()
        data = data.reduce((temp, vv) => {
            temp.push({ id: vv._id, display: vv.name });
            return temp;
        }, [])
        this.setState({ counsellorsArr: data })
    }

    componentDidMount() {
        this.loadFollowUpTypes();
    }

    handleSubmit = (e) => {
        let { form, record } = this.props;
        e.preventDefault();
        form.validateFieldsAndScroll(async (err, valData) => {
            let values = _.clone(valData);

            let dataToSend = {
                followUp: {
                    followUpType: values.followUpType,
                    followUpDate: values.followUpDate,
                    detail: values.detail
                },
                _id: record._id,
                status: 'Disapproved'
            }
            if (values.reassignLead && values.totalPreference.length > 0) {
                let totalPreference = [];
                async.each(values.totalPreference, (preference) => {
                    let foundCountry = this.state.countriesArr.find((obj) => {
                        return obj.id === preference;
                    })
                    if (record.type === "inquiry") {
                        if (foundCountry) {
                            totalPreference.push({ country: foundCountry.display, countryId: foundCountry.id });
                        }
                    } else if (record.type === "rawInquiry") {
                        if (foundCountry) {
                            totalPreference.push(foundCountry.display);
                        }
                    }
                })
                dataToSend.totalPreference = totalPreference;
                dataToSend.counsellorId = values.counsellorId;
                dataToSend.reassignLead = values.reassignLead;
                if (values.atLevel) {
                    dataToSend.atLevel = values.atLevel;
                }
            }
            let response = await Request.updateDroppedLeadStatus(dataToSend);
            if (response.success) {
                notification.success({
                    message: response.message
                })
            } else {
                notification.error({
                    message: response.message
                })
            }
            this.onClose();
        })
    }


    render() {
        let { visible } = this.state;
        let { form: { setFieldsValue, getFieldDecorator } } = this.props;
        let inputTypes = {
            fields: [
                {
                    label: 'Next Follow Up Date',
                    key: 'followUpDate',
                    type: 'date',
                    required: true
                },
                {
                    label: 'Details',
                    key: 'detail',
                    type: 'textArea',
                    rows: 10,
                    required: true
                },
                {
                    label: 'FollowUp Out Come',
                    key: 'followUpType',
                    type: 'select',
                    required: true,
                    options: this.state.followUpObject,
                    placeholder: 'Select followUp Type',
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            followUpType: v
                        })
                    }
                },
                {
                    label: 'Want To Reassign?',
                    key: 'reassignLead',
                    type: 'checkbox',
                    onChange: v => {
                        if (v.target.checked === true) {
                            this.setFormData();
                            this.loadCountries();
                            this.loadCounsellors();
                        }
                        this.setState({ reassignLead: v.target.checked })
                        this.props.form.setFieldsValue({
                            reassignLead: v.target.checked
                        })
                    }
                },
                {
                    label: 'Select Counsellor',
                    key: 'counsellorId',
                    showSearch: true,
                    options: this.state.counsellorsArr,
                    type: 'select',
                    hidden: !this.state.reassignLead,
                    required: this.state.reassignLead,
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            counsellorId: v
                        })
                    }
                },
                {
                    label: 'Select Desk',
                    key: 'atLevel',
                    options: [{ id: 'Operation Manager Desk', display: 'Operation Manager Desk' }, { id: 'Front Desk', display: 'Counselling Desk' }, { id: 'Registration Desk', display: 'Registration Desk' }, { id: 'Application Desk', display: 'Application Desk' }, { id: 'Visa Desk', display: 'Visa Desk' }],
                    type: 'select',
                    hidden: this.props.record.type === "rawInquiry" || !this.state.reassignLead,
                    required: this.state.reassignLead && this.props.record.type === "inquiry",
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            atLevel: v
                        })
                    }
                },
                {
                    label: 'Preference',
                    key: 'totalPreference',
                    options: this.state.countriesArr,
                    type: 'select',
                    mode: 'multiple',
                    hidden: !this.state.reassignLead,
                    required: this.state.reassignLead,
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            totalPreference: v
                        })
                    }
                }
            ]
        }
        return (
            <Drawer
                title={`Disapprove FollowUp`}
                placement={"right"}
                width={600}
                closable={true}
                onClose={this.onClose}
                visible={visible}
            >
                <Card bordered={true}>
                    <Form onSubmit={this.handleSubmit}>
                        <GetAllFormFields apiurl={LAPI_URL} getFieldDecorator={getFieldDecorator} inputSchema={inputTypes} />
                        <Row>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.props.loading}>
                                    SAVE
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}

class DroppedLeads extends React.Component {
    state = {
        activeKey: '0',
        showFollowUp: false,
        showRawFollowUp: false,
        showCallDrawer: false,
        recordForCall: {},
        showDisapprovedDrawer: false,
        recordId: null,
        showCommunicationDrawer: false,
    }


    openFollowUps = (record) => {
        studentObj = {
            name: record.studentName,
            _id: record.inquiryId,
        };
        this.setState({ showFollowUp: true });
    };


    openCommunicationHistory = (record) => {
        this.setState({ showCommunicationDrawer: true, recordId: record.inquiryId });
    }

    closeCommunicationHistory = () => {
        this.setState({ showCommunicationDrawer: false, recordId: null });
    }


    openRawFollowUps = (record) => {
        rawStudentObj = {
            name: record.studentName,
            _id: record.inquiryId
        }
        this.setState({ showRawFollowUp: true });
    }


    reload = () => {
        this.table.current.reload();
    };


    closeFollowUp = () => {
        this.setState({ showFollowUp: false });
        this.reload();
    };

    closeRawFollowUp = () => {
        this.setState({ showRawFollowUp: false });
        this.reload();
    }

    componentDidMount() {

    }

    constructor(props) {
        super(props);
        this.table = React.createRef();
    }

    apiRequest = (params, status) => {
        return new Promise(async (resolve) => {
            params.status = status;
            let response = await Request.getDroppedLeadsList(params);
            return resolve(response)
        })
    }

    onChange = activeKey => {
        this.setState({ activeKey })
    }

    closeCallDrawer = () => {
        this.setState({ showCallDrawer: false, recordForCall: {} }, () => {
            this.reload()
        })
    }


    closeDisapproveDrawer = () => {
        this.setState({ showDisapprovedDrawer: false, record: null }, () => {
            this.reload()
        })
    }
    updateStatus = async (record, status) => {
        let dataToSend = {
            _id: record._id,
            status
        }
        let response = await Request.updateDroppedLeadStatus(dataToSend);
        if (response.success) {
            notification.success({
                message: response.message
            })
        } else {
            notification.error({
                message: response.message
            })
        }
        this.reload();
    }


    render() {
        let { activeKey } = this.state;
        const columns = [
            {
                title: 'Sr. No',
                key: 'serialNumber',
                render: (text, record, index) => (
                    <div>{index + 1}</div>
                )
            },
            {
                title: 'Action',
                key: 'operation',
                width: 200,
                render: (text, record) => (
                    <div>
                        {record.type === "inquiry" ?
                            <>
                                <Tooltip title="View Communication History">
                                    <Button
                                        shape="circle"
                                        size="small"
                                        style={{ marginLeft: "5px" }}
                                        onClick={() => this.openCommunicationHistory(record)}
                                        icon="history"
                                    />
                                </Tooltip>
                                <Tooltip title="View followups">
                                    <Button
                                        shape="circle"
                                        size="small"
                                        style={{ marginLeft: "5px" }}
                                        onClick={() => this.openFollowUps(record)}
                                        icon="eye"
                                    />
                                </Tooltip>
                            </>
                            : <Tooltip title="View followups">
                                <Button
                                    shape="circle"
                                    size="small"
                                    style={{ marginLeft: "5px" }}
                                    onClick={() => this.openRawFollowUps(record)}
                                    icon="eye"
                                />
                            </Tooltip>}
                        {
                            record.status === "Pending" ?
                                <>
                                    <Tooltip title="Approve">
                                        <Button shape="circle" size="small" style={{ marginLeft: "5px" }}
                                            icon="check" onClick={() => this.updateStatus(record, 'Approved')} />
                                    </Tooltip>
                                    <Tooltip title="Disapprove">
                                        <Button shape="circle" size="small" style={{ marginLeft: "5px" }}
                                            icon="cross" onClick={() => this.setState({ showDisapprovedDrawer: true, record: record })} />
                                    </Tooltip>
                                    <Tooltip title="Under Review">
                                        <Button shape="circle" size="small" style={{ marginLeft: "5px" }}
                                            icon="forward" onClick={() => this.updateStatus(record, 'Under Review')} />
                                    </Tooltip>
                                </>
                                : record.status === "Disapproved" ?
                                    <>
                                        <Tooltip title="Under Review">
                                            <Button shape="circle" size="small" style={{ marginLeft: "5px" }}
                                                icon="forward" onClick={() => this.updateStatus(record, 'Under Review')} />
                                        </Tooltip>
                                    </>
                                    : record.status === "Under Review" ?
                                        <>
                                            <Tooltip title="Approve">
                                                <Button shape="circle" size="small" style={{ marginLeft: "5px" }}
                                                    icon="check" onClick={() => this.updateStatus(record, 'Approved')} />
                                            </Tooltip>
                                            <Tooltip title="Disapprove">
                                                <Button shape="circle" size="small" style={{ marginLeft: "5px" }}
                                                    icon="cross" onClick={() => this.updateStatus(record, 'Disapproved')} />
                                            </Tooltip>
                                        </>
                                        : null
                        }
                    </div>
                )
            },
            {
                title: 'Inquiry Type',
                key: 'type'
            },
            {
                title: 'Student Name',
                key: 'studentName'
            },
            {
                title: 'V.I.D',
                key: 'studentId'
            },
            {
                title: 'Mobile Number',
                key: 'mobile',
                width: 150,
                render: (val, record) => {
                    return (
                        <div>
                            {" "}
                            {val &&
                                val.length >= 10 &&
                                rightAuth.checkRights("ShowClickToCall.view") ? (
                                <Tooltip title="Start Call">
                                    <Button
                                        className="ant-btn ant-btn-primary"
                                        onClick={() => {
                                            this.setState({ showCallDrawer: true, recordForCall: { _id: record.inquiryId, id: record.studentId, studentName: record.studentName, mobile: record.mobile, gender: record.gender, countryCode: record.countryCode, type: record.type } })
                                        }}
                                    >
                                        Click To Call
                                    </Button>
                                </Tooltip>
                            ) : (
                                val
                            )}
                        </div>
                    );
                },
            },
            {
                title: 'Mode',
                key: 'mode',
            },
            {
                title: "Follow Up",
                key: "followUp.followUpType",
                width: 200,
                dataIndex: "followUp",
                render: (text, record) => {
                    return <LatestFollowUp info={text} />;
                },
            },
            {
                title: 'Call Remark',
                key: 'last_call_remark.remark'
            }
        ]
        return (
            <PageHeaderWrapper title="Dropped Leads">
                {this.state.showFollowUp ? (
                    <ListFollowUps studentObj={studentObj} onClose={this.closeFollowUp} />
                ) : null}
                {
                    this.state.showRawFollowUp ?
                        <ListRawFollowUp studentObj={rawStudentObj} onClose={this.closeRawFollowUp} />
                        : null
                }
                {
                    this.state.showCallDrawer ?
                        <ClickToCallDrawer record={this.state.recordForCall} type={this.state.recordForCall.type} onClose={this.closeCallDrawer} />
                        : null
                }
                {
                    this.state.showDisapprovedDrawer ?
                        <DisapproveFollowUp record={this.state.record} onClose={this.closeDisapproveDrawer} />
                        : null
                }

                {
                    this.state.showCommunicationDrawer ?
                        <CommunicationHistoryDrawer studentId={this.state.recordId} onClose={this.closeCommunicationHistory} />
                        : null
                }
                <Card bordered={true}>
                    <Tabs activeKey={activeKey} onChange={this.onChange} type="card">
                        <TabPane tab={"Pending"} key={0}>
                            <Card bordered={true}>
                                <TableComp
                                    ref={this.table}
                                    columns={columns}
                                    apiRequest={(params) => this.apiRequest(params, 'Pending')}
                                    extraProps={{ scroll: { x: 900 } }}
                                    pagination={{
                                        showSizeChanger: true,
                                        defaultPageSize: 10,
                                        pageSizeOptions: ['10', '20', '50', '100', '1000']
                                    }}
                                />
                            </Card>
                        </TabPane>
                        <TabPane tab={"Approved"} key={1}>
                            <Card bordered={true}>
                                <TableComp
                                    ref={this.table}
                                    columns={columns}
                                    apiRequest={(params) => this.apiRequest(params, 'Approved')}
                                    extraProps={{ scroll: { x: 900 } }}
                                    pagination={{
                                        showSizeChanger: true,
                                        defaultPageSize: 10,
                                        pageSizeOptions: ['10', '20', '50', '100', '1000']
                                    }}
                                />
                            </Card>
                        </TabPane>
                        <TabPane tab={"Disapproved"} key={2}>
                            <Card bordered={true}>
                                <TableComp
                                    ref={this.table}
                                    columns={columns}
                                    apiRequest={(params) => this.apiRequest(params, 'Disapproved')}
                                    extraProps={{ scroll: { x: 900 } }}
                                    pagination={{
                                        showSizeChanger: true,
                                        defaultPageSize: 10,
                                        pageSizeOptions: ['10', '20', '50', '100', '1000']
                                    }}
                                />
                            </Card>
                        </TabPane>
                        <TabPane tab={"Under Review"} key={3}>
                            <Card bordered={true}>
                                <TableComp
                                    ref={this.table}
                                    columns={columns}
                                    apiRequest={(params) => this.apiRequest(params, 'Under Review')}
                                    extraProps={{ scroll: { x: 900 } }}
                                    pagination={{
                                        showSizeChanger: true,
                                        defaultPageSize: 10,
                                        pageSizeOptions: ['10', '20', '50', '100', '1000']
                                    }}
                                />
                            </Card>
                        </TabPane>
                    </Tabs>
                </Card>
            </PageHeaderWrapper>
        )
    }
}



const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DroppedLeads)